enum SameSite {
    Lax,
    Strict,
    None
}

export default SameSite;
